import axios from 'axios';
import { chain } from 'lodash';
import { apiInstancesLinksUrl } from '../config';
import InstanceLink from '../models/instance/InstanceLink';

/**
 * POST Post Put Instance Links.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {[]} [props.instanceLinksToCreate]
 * @param {{}} [props.method=post] - post | put
 * @param {{}} [props.type=post] - post | put
 * @returns {Promise}
 */
const postPutInstanceLinks = props => {
  const {
    instanceLinksToCreate,
    method = 'post',
    requestConfig,
    type = 'post'
  } = props;

  const url = apiInstancesLinksUrl;

  const instanceLinks = chain(instanceLinksToCreate)
    .map(
      instanceLink =>
        new InstanceLink({
          appliesToInstanceProfile: true,
          instanceProfileCanSeeLinkedProfile: true,
          instanceProfileCanViewData: true,
          ...instanceLink
        })
    )
    .value();

  return axios({
    data: instanceLinks,
    method: method || type,
    url,
    ...requestConfig
  });
};

export default postPutInstanceLinks;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/postPutInstanceLinks.js